'use client';

import React from 'react';
import { Stethoscope, Syringe, Pill, AlertTriangle } from 'lucide-react';
import { MOCK_HEALTH_RECORDS, MOCK_VACCINATIONS, MOCK_MEDICATIONS } from './healthData';
import { StatCard } from '@/components/ui/Cards';


export default function HealthSummaryCards() {
  const openCases = MOCK_HEALTH_RECORDS?.filter(r => r?.status === 'open' || r?.status === 'under-treatment')?.length;
  const overdueVaccinations = MOCK_VACCINATIONS?.filter(v => v?.status === 'overdue')?.length;
  const dueVaccinations = MOCK_VACCINATIONS?.filter(v => v?.status === 'due')?.length;
  const activeMedications = MOCK_MEDICATIONS?.filter(m => m?.status === 'active')?.length;
  const withdrawalAlerts = MOCK_MEDICATIONS?.filter(m => m?.withdrawalAlert)?.length;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
      <StatCard
        label="Active Health Cases"
        value={openCases}
        sub={`${MOCK_HEALTH_RECORDS?.filter(r => r?.status === 'resolved')?.length} resolved this month`}
        icon={Stethoscope}
        iconBg={openCases > 0 ? '#fef2f2' : '#f0fdf4'}
        iconColor={openCases > 0 ? '#dc2626' : '#16a34a'}
        alert={openCases > 0}
        alertVariant="danger"
      />
      <StatCard
        label="Vaccinations Due / Overdue"
        value={dueVaccinations + overdueVaccinations}
        sub={`${overdueVaccinations} overdue · ${dueVaccinations} due soon`}
        icon={Syringe}
        iconBg={overdueVaccinations > 0 ? '#fef2f2' : dueVaccinations > 0 ? '#fffbeb' : '#f0fdf4'}
        iconColor={overdueVaccinations > 0 ? '#dc2626' : dueVaccinations > 0 ? '#d97706' : '#16a34a'}
        alert={overdueVaccinations > 0}
        alertVariant="danger"
      />
      <StatCard
        label="Active Medications"
        value={activeMedications}
        sub={`${MOCK_MEDICATIONS?.filter(m => m?.status === 'completed')?.length} completed this month`}
        icon={Pill}
        iconBg="#fffbeb"
        iconColor="#d97706"
      />
      <StatCard
        label="Withdrawal Alerts"
        value={withdrawalAlerts}
        sub="Birds/eggs under withdrawal period"
        icon={AlertTriangle}
        iconBg={withdrawalAlerts > 0 ? '#fef2f2' : '#f0fdf4'}
        iconColor={withdrawalAlerts > 0 ? '#dc2626' : '#16a34a'}
        alert={withdrawalAlerts > 0}
        alertVariant="danger"
      />
    </div>
  );
}
